import React, { useState, useEffect } from 'react';
import styles from './analytics.module.scss';
import { Col, Row, Card, Dropdown, DropdownButton, Form, FormControl, Modal, Button } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../customNavbar';
import { Chart } from "react-google-charts";
import CSSLoader from '../../shared/cssLoader';
import { Formik } from 'formik';
import { CustomButton } from '../../shared/customButton';
import 'react-month-picker/css/month-picker.css';
import * as yup from 'yup';
import {
    overall_analytics_options,
    shareable_link_analytics_options,
    pieAnalyticsOptions,
    offer_acceptance_rate_options,
    selection_ratio_options,
    time_to_hire_options,
    pieAnalyticsOptionsDataNone,
    pieOptions,
    pieOptionsDataNone
} from './chartsDesignsVariables';
import Select from 'react-select';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { getOverallSourceAnalytics, getSourceAnalyticsMonthlyTrend } from '../../../services/util/analytics/sourceAnalytics';
import { getProcessKpi, getProcessKpisMonthlyTrend } from '../../../services/util/analytics/processKPIs';
import { CustomAlertBox } from '../../shared/customAlertBox';
let moment = require("moment");

const Analytics = (props) => {

    //state for select source analytics or processed KPIs
    let [activeTopic, setActiveTopic] = useState(0);

    //source analytics section monthly trend dropdown data set
    const allTrendTypes = [
        {
            value: 0,
            label: 'Overall'
        },
        {
            value: 1,
            label: 'Shareable Links'
        }
    ];

    //kpi section monthly trend dropdown data set
    const kpiSectionAllTrendTypes = [
        {
            value: 0,
            label: 'Selection Ratio'
        },
        {
            value: 1,
            label: 'Offer Acceptance Rate'
        },
        {
            value: 2,
            label: 'Time To Hire'
        }
    ];

    //source analytics section monthly trend dropdown default data set
    let [defaultSelectedTrendType, setDefaultSelectedTrendType] = useState({
        value: 0,
        label: 'Overall'
    });

    //kpi section monthly trend dropdown default data set
    let [kpiSectionDefaultSelectedTrendType, setKpiSectionDefaultSelectedTrendType] = useState({
        value: 0,
        label: 'Selection Ratio'
    });

    //custom range selection modal
    let [ModalState, setModalState] = useState({
        is_modal_open: false,
        modal_type: null
    });

    //start date and end date of custom date range
    const [startDate, setStartDate] = useState(new Date(moment().subtract(3, 'months')));
    const [endDate, setEndDate] = useState(new Date());
    const [selectedSingleDate, setselectedSingleDate] = useState(new Date());

    //calendar type selection states
    let [sourceAnalyticsOverallPerformanceCalendarType, setSourceAnalyticsOverallPerformanceCalendarType] = useState(0);
    let [sourceAnalyticsMonthlyTrendCalendarType, setSourceAnalyticsMonthlyTrendCalendarType] = useState(0);
    let [kpiCalendarType, setKpiCalendarType] = useState(0);
    let [kpiMonthlyTrendCalendarType, setKpiMonthlyTrendCalendarType] = useState(0);
    let [chartStatus, setChartStatus] = useState(false);

    //month range of source analytics
    let [source_analytics_month_range, set_source_analytics_month_range] = useState({
        to: '',
        from: ''
    });

    //month range of source analytics month trend
    let [source_analytics_monthly_trend_range, set_source_analytics_monthly_trend_range] = useState({
        to: '',
        from: ''
    });

    //month range of kpi
    let [kpi_month_range, set_kpi_month_range] = useState({
        to: '',
        from: ''
    });

    //month range of kpi month trend
    let [kpi_monthly_trend_range, set_kpi_monthly_trend_range] = useState({
        to: '',
        from: ''
    });

    //source analytics data set
    let [sourceAnalyticsDataSet, setSourceAnalyticsDataSet] = useState({
        overall_analytics: {},
        shareable_link_analytics: {}
    });

    //kpi analytics data set
    let [kpiAnalyticsDataSet, setKpiAnalyticsDataSet] = useState({
        offer_acceptance_rate: null,
        selection_ratio: null,
        time_to_hire: null
    });

    //source analytics monthly trends data set
    let [sourceAnalyticsMonthlyTrendDataSet, setSourceAnalyticsMonthlyTrendDataSet] = useState({
        overall_analytics: [],
        shareable_link_analytics: [],
    });

    //kpi analytics monthly trends data set
    let [kpiMonthlyTrendDataSet, setKpiMonthlyTrendDataSet] = useState({
        offer_acceptance_rate: [],
        selection_ratio: [],
        time_to_hire: []
    });

    //set page loading
    let [isDataLoading, setDataLoading] = useState(false);

    // Calculate the first day of the next month
    const maxDate = moment().add(0, 'month').startOf('month').toDate();

    //breadcrumb
    const breadcrumb = [
        {
            pathaddress: '/',
            pathname: 'Analytics',
            isActive: true,
            key: 1 + 'Analytics'
        }
    ];

    //yup validations company contact
    const monthRangeSchema = yup.object({
        selectedMonth: yup.date().nullable().required('selected month is required'),
        startDate: yup.date().nullable().required('start month is required'),
        endDate: yup.date().nullable().required('end month is required'),
    });


    //load default values
    const generateDefaultAnalytics = async () => {
        setDataLoading(true);
        let current_month = moment().format('YYYYMM');
        let previous_three_month = moment().subtract(2, 'months').format('YYYYMM');
        let startMonth = moment().subtract(2, 'months').format('MMM YYYY');
        let endMonth = moment().format('MMM YYYY');
        set_source_analytics_month_range({
            to: endMonth,
            from: endMonth
        });
        set_source_analytics_monthly_trend_range({
            to: endMonth,
            from: startMonth
        });

        let source_data = await getOverallSourceAnalytics(current_month, current_month);
        let source_monthly_trend_data = await getSourceAnalyticsMonthlyTrend(previous_three_month, current_month);

        if (source_data.success && source_monthly_trend_data.success) {
            convertAnalyticsMonthlyData(source_monthly_trend_data.data.monthly_analytics_data);
            setSourceAnalyticsDataSet(source_data.data);
            generateDefaultKpiAnalytics();
        } else {
            setDataLoading(false);
        }
    }

    //load default kpi values
    const generateDefaultKpiAnalytics = async () => {
        let current_month = moment().format('YYYYMM');
        let previous_three_month = moment().subtract(2, 'months').format('YYYYMM');
        let startMonth = moment().subtract(2, 'months').format('MMM YYYY');
        let endMonth = moment().format('MMM YYYY');
        set_kpi_month_range({
            to: endMonth,
            from: endMonth
        });
        set_kpi_monthly_trend_range({
            to: endMonth,
            from: startMonth
        });

        let kpi_data = await getProcessKpi(current_month, current_month);
        let kpi_monthly_trend_data = await getProcessKpisMonthlyTrend(previous_three_month, current_month);

        if (kpi_data.success && kpi_monthly_trend_data.success) {
            convertKpiAnalyticsMonthlyData(kpi_monthly_trend_data.data.monthly_analytics_data);
            setKpiAnalyticsDataSet(kpi_data.data);
            setDataLoading(false);
        } else {
            setDataLoading(false);
        }

    }

    //convert data to show source analytics monthly trend line chart
    const convertAnalyticsMonthlyData = (values) => {
        let overall_analytics = [['Year-Month', 'External Recruiter Count', 'Internal Referral Count', 'Other Uploads Count', 'Registered From Invitation Count', 'Registered From Shareable Link Count']];
        let shareable_link_analytics = [['Year-Month', 'Career Page Count', 'Facebook Count', 'From A Friend Count', 'Linkedin Count', 'Other Count']];

        for (let index = 0; index < values.length; index++) {
            let overallValue = [];
            let shareableValue = [];

            //overall array
            overallValue.push(values[index].month_identifier);
            overallValue.push(values[index].month_analytics.overall_analytics.from_external_recruiters_count);
            overallValue.push(values[index].month_analytics.overall_analytics.internal_referral_count);
            overallValue.push(values[index].month_analytics.overall_analytics.other_uploads);
            overallValue.push(values[index].month_analytics.overall_analytics.registered_from_invitation_count);
            overallValue.push(values[index].month_analytics.overall_analytics.registered_from_shareable_link_count);
            overall_analytics.push(overallValue);

            //shreable array
            shareableValue.push(values[index].month_identifier);
            shareableValue.push(values[index].month_analytics.shareable_link_analytics.career_page_count);
            shareableValue.push(values[index].month_analytics.shareable_link_analytics.facebook_count);
            shareableValue.push(values[index].month_analytics.shareable_link_analytics.from_a_friend_count);
            shareableValue.push(values[index].month_analytics.shareable_link_analytics.linkedin_count);
            shareableValue.push(values[index].month_analytics.shareable_link_analytics.other_count);
            shareable_link_analytics.push(shareableValue);

        }

        setSourceAnalyticsMonthlyTrendDataSet({
            overall_analytics: overall_analytics,
            shareable_link_analytics: shareable_link_analytics,
        });
    }

    //convert data to show kpi analytics monthly trend line chart
    const convertKpiAnalyticsMonthlyData = (values) => {
        let offer_acceptance_rate_analytics = [['Year-Month', 'Offer Acceptance Rate']];
        let selection_ratio_analytics = [['Year-Month', 'Selection Ratio']];
        let time_to_hire_analytics = [['Year-Month', 'Time To Hire']];

        for (let index = 0; index < values.length; index++) {
            let acceptanceRateValue = [];
            let selectionRatioValue = [];
            let timeToHireValue = [];

            //acceptance rate array
            acceptanceRateValue.push(values[index].month_identifier);
            acceptanceRateValue.push(values[index].month_analytics.offer_acceptance_rate);
            offer_acceptance_rate_analytics.push(acceptanceRateValue);

            //selection ratio array
            selectionRatioValue.push(values[index].month_identifier);
            selectionRatioValue.push(values[index].month_analytics.selection_ratio);
            selection_ratio_analytics.push(selectionRatioValue);

            //time to hire array
            timeToHireValue.push(values[index].month_identifier);
            timeToHireValue.push(values[index].month_analytics.time_to_hire);
            time_to_hire_analytics.push(timeToHireValue);
        }

        setKpiMonthlyTrendDataSet({
            offer_acceptance_rate: offer_acceptance_rate_analytics,
            selection_ratio: selection_ratio_analytics,
            time_to_hire: time_to_hire_analytics
        })
    }

    //load source analytics
    const onClickSourceAnalyticsCurrentMonth = async () => {
        setDataLoading(true);
        let current_month = moment().format('YYYYMM');
        let endMonth = moment().format('MMM YYYY');
        set_source_analytics_month_range({
            to: endMonth,
            from: endMonth
        });
        //change calendar dropdown label
        setSourceAnalyticsOverallPerformanceCalendarType(0);
        let source_data = await getOverallSourceAnalytics(current_month, current_month);
        let kpi_data = await getProcessKpi(current_month, current_month);
        if (source_data.success) {
            setSourceAnalyticsDataSet(source_data.data);  
            setKpiAnalyticsDataSet(kpi_data.data);
            setDataLoading(false);
        } else {
            setDataLoading(false);
        }
    }

    //monthly trend past 03 months
    const MonthlyTrendPastThreeMonths = async () => {
        setDataLoading(true);
        let current_month = moment().format('YYYYMM');
        let previous_three_month = moment().subtract(2, 'months').format('YYYYMM');
        let label_start_month = moment().subtract(2, 'months').format('MMM YYYY');
        let label_end_month = moment().format('MMM YYYY');
        set_kpi_monthly_trend_range({
            to: label_end_month,
            from: label_start_month
        });
        set_source_analytics_monthly_trend_range({
            to: label_end_month,
            from: label_start_month
        });
        setKpiMonthlyTrendCalendarType(0);
        setSourceAnalyticsMonthlyTrendCalendarType(0);
        let kpi_monthly_trend_data = await getProcessKpisMonthlyTrend(previous_three_month, current_month);
        if (kpi_monthly_trend_data.success) {
            convertKpiAnalyticsMonthlyData(kpi_monthly_trend_data.data.monthly_analytics_data);
        } else {
            setDataLoading(false);
        }

        let source_monthly_trend_data = await getSourceAnalyticsMonthlyTrend(previous_three_month, current_month);
        if (source_monthly_trend_data.success) {
            convertAnalyticsMonthlyData(source_monthly_trend_data.data.monthly_analytics_data);
            setDataLoading(false);
        } else {
            setDataLoading(false);
        }
    }

    //custom date range selection
    const onClickCustomDateRange = ({ is_modal_open, modal_type }) => {
        setModalState({ is_modal_open: is_modal_open, modal_type: modal_type })
        if (modal_type === 1) {
            setChartStatus(true);
        }
    }

    //custom data range modal close
    const onCloseCustomDateRangeModal = () => {
        setModalState({ is_modal_open: false, modal_type: null });
    }

    //on submit date range
    const onSubmitDateRange = async (values) => {
        setChartStatus(false);
        onCloseCustomDateRangeModal();
        setDataLoading(true);

        let start_month = null;
        let end_month = null;
        let label_end_month = null;
        let label_start_month = null;

        //if range type is single month range start and end month to selected month
        if (values.rangeType === 0) {
            start_month = moment(values.selectedMonth).format('YYYYMM');
            end_month = moment(values.selectedMonth).format('YYYYMM');
            label_start_month = moment(values.selectedMonth).format('MMM YYYY');
            label_end_month = moment(values.selectedMonth).format('MMM YYYY');
        }
        else if(values.rangeType !== 0){
            start_month = moment(values.startDate).format('YYYYMM');
            end_month = moment(values.endDate).format('YYYYMM');
            label_end_month = moment(values.endDate).format('MMM YYYY');
            label_start_month = moment(values.startDate).format('MMM YYYY');
        }

        if (ModalState.is_modal_open && ModalState.modal_type === 0) {

            set_source_analytics_month_range({
                to: label_end_month,
                from: label_start_month
            });

            let source_data = await getOverallSourceAnalytics(start_month, end_month);
            let kpi_data = await getProcessKpi(start_month, end_month);

            if (source_data.success) {
                setSourceAnalyticsDataSet(source_data.data);
                setKpiAnalyticsDataSet(kpi_data.data);
                setDataLoading(false);
            } else {
                setDataLoading(false);
            }

            if (activeTopic === 0 && values.rangeType === 0) {
                //change calendar dropdown label
                setSourceAnalyticsOverallPerformanceCalendarType(0);
            }
            if (activeTopic === 0 && values.rangeType === 1) {
                //change calendar dropdown label
                setSourceAnalyticsOverallPerformanceCalendarType(1);
            }
        }
        if (ModalState.is_modal_open && ModalState.modal_type === 1) {
            if (activeTopic === 1) {
                set_kpi_monthly_trend_range({
                    to: label_end_month,
                    from: label_start_month
                })
                //set activated calendar type
                setKpiMonthlyTrendCalendarType(1);

                let source_monthly_trend_data = await getSourceAnalyticsMonthlyTrend(start_month, end_month);

                if (source_monthly_trend_data.success) {
                    convertAnalyticsMonthlyData(source_monthly_trend_data.data.monthly_analytics_data);
                } else {
                    setDataLoading(false);
                }

                let kpi_monthly_trend_data = await getProcessKpisMonthlyTrend(start_month, end_month);
                if (kpi_monthly_trend_data.success) {
                    convertKpiAnalyticsMonthlyData(kpi_monthly_trend_data.data.monthly_analytics_data);
                    setDataLoading(false);
                } else {
                    setDataLoading(false);
                }
            }
        }
    }

    //date input text box customize design
    const Input = ({ onChange, placeholder, value, isSecure, id, onClick }) => (
        <div>
            <FormControl
                onChange={onChange}
                placeholder={placeholder}
                value={value}
                isSecure={isSecure}
                id={id}
                onClick={onClick}
                className={styles.dateInputInputBox}
            />
            <div className={styles.calendarIconDiv}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 1.5V4.5" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6 1.5V4.5" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2.25 7.5H15.75" stroke="#979797" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </div>
    );

    useEffect(() => {
        generateDefaultAnalytics();
    }, [])

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [])

    return (
        <div>
            <Helmet>
                <title>Analytics | HireTrace</title>
            </Helmet>

            {isDataLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>

                    {/* Custom modal to select month and year start */}
                    <Modal
                        show={ModalState.is_modal_open}
                        onHide={() => onCloseCustomDateRangeModal()}
                        backdrop="static"
                        keyboard={false}
                        centered
                        size="md"
                    >
                        <Modal.Body>
                            <div className={styles.modalCancelBtnDiv}>
                                <Button className={styles.modalCancelBtn} onClick={() => {setChartStatus(false); onCloseCustomDateRangeModal()}}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </Button>
                            </div>
                            <div className={styles.popUpBoxTopicDiv}>
                                <p className={styles.popUpBoxTopic}>
                                    Custom Time Period
                                </p>
                            </div>
                            <Formik
                                validationSchema={monthRangeSchema}
                                onSubmit={(values) => onSubmitDateRange(values)}
                                initialValues={{ rangeType: startDate && endDate ? 1 : 0, selectedMonth: selectedSingleDate, startDate: startDate, endDate: endDate }}>

                                {({
                                    values,
                                    setFieldValue,
                                    handleSubmit,
                                    errors,
                                    submitCount,
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <Col>
                                            {chartStatus === false &&
                                                <div key={`inline-radio`} className="mb-3">
                                                    <p className={styles.formLabel}>Type</p>

                                                    <Form.Check
                                                        inline
                                                        label="Single Month"
                                                        name="rangeType"
                                                        type="radio"
                                                        checked={values.rangeType === 0 ? true : false}
                                                        onChange={() => setFieldValue('rangeType', 0)}
                                                        className={styles.radioBtns}
                                                        id={`inline-radio-1`}
                                                    />


                                                    <Form.Check
                                                        inline
                                                        label="Month Range"
                                                        name="rangeType"
                                                        type="radio"
                                                        checked={values.rangeType === 1 ? true : false}
                                                        className={styles.radioBtns}
                                                        onChange={() => setFieldValue('rangeType', 1)}
                                                        id={`inline-radio-2`}
                                                    />
                                                </div>
                                            }
                                           
                                            {chartStatus === false &&
                                                <>
                                                    {values.rangeType === 0 ?

                                                        <div>
                                                            <p className={styles.formLabel}>Month</p>
                                                            <DatePicker
                                                                selected={selectedSingleDate}
                                                                onChange={(date) => { setselectedSingleDate(date); setFieldValue('selectedMonth', date); }}
                                                                selectsStart
                                                                startDate={selectedSingleDate}
                                                                dateFormat="MM/yyyy"
                                                                showMonthYearPicker
                                                                maxDate={maxDate}
                                                                customInput={<Input />}
                                                            />
                                                            {submitCount > 0 &&
                                                                <p className={styles.monthErrorMsg}>{errors.selectedMonth}</p>
                                                            }
                                                        </div>
                                                        : values.rangeType === 1 ?
                                                            <div className={styles.monthRangeMain}>
                                                                <Col sm={5}>
                                                                    <p className={styles.formLabel}>Start Month</p>
                                                                    <DatePicker
                                                                        selected={startDate}
                                                                        onChange={(date) => { setStartDate(date); setFieldValue('startDate', date);}}
                                                                        selectsStart
                                                                        startDate={startDate}
                                                                        dateFormat="MM/yyyy"
                                                                        showMonthYearPicker
                                                                        maxDate={maxDate}
                                                                        customInput={<Input />}
                                                                    />
                                                                    {submitCount > 0 &&
                                                                        <p className={styles.monthErrorMsg}>{errors.startDate}</p>
                                                                    }
                                                                </Col>
                                                                <Col sm={1} className={styles.monthRangeMiddleDiv}>
                                                                    <p className={styles.monthRangeMiddleText}>to</p>
                                                                </Col>
                                                                <Col sm={5}>
                                                                    <p className={styles.formLabel}>End Month</p>
                                                                    <DatePicker
                                                                        selected={endDate}
                                                                        onChange={(date) => { setEndDate(date); setFieldValue('endDate', date);}}
                                                                        selectsEnd
                                                                        endDate={endDate}
                                                                        dateFormat="MM/yyyy"
                                                                        showMonthYearPicker
                                                                        customInput={<Input />}
                                                                        minDate={startDate}
                                                                        maxDate={maxDate}
                                                                    />
                                                                    {submitCount > 0 &&
                                                                        <p className={styles.monthErrorMsg}>{errors.endDate}</p>
                                                                    }
                                                                </Col>
                                                            </div>
                                                            : null
                                                    }
                                                </>
                                            }
                                             {chartStatus === true &&
                                                <div>
                                                    <p className={styles.formLabel}>Select Month Range</p>
                                                </div>

                                            }
                                            {chartStatus === true &&
                                                <div className={styles.monthRangeMain}>
                                                    <Col sm={5}>
                                                        <p className={styles.formLabel}>Start Month</p>
                                                        <DatePicker
                                                            selected={startDate}
                                                            onChange={(date) => { setStartDate(date); setFieldValue('startDate', date); }}
                                                            selectsStart
                                                            startDate={startDate}
                                                            dateFormat="MM/yyyy"
                                                            showMonthYearPicker
                                                            maxDate={maxDate}
                                                            customInput={<Input />}
                                                        />
                                                        {submitCount > 0 &&
                                                            <p className={styles.monthErrorMsg}>{errors.startDate}</p>
                                                        }
                                                    </Col>
                                                    <Col sm={1} className={styles.monthRangeMiddleDiv}>
                                                        <p className={styles.monthRangeMiddleText}>to</p>
                                                    </Col>
                                                    <Col sm={5}>
                                                        <p className={styles.formLabel}>End Month</p>
                                                        <DatePicker
                                                            selected={endDate}
                                                            onChange={(date) => { setEndDate(date); setFieldValue('endDate', date); }}
                                                            selectsEnd
                                                            endDate={endDate}
                                                            dateFormat="MM/yyyy"
                                                            showMonthYearPicker
                                                            customInput={<Input />}
                                                            minDate={startDate}
                                                            maxDate={maxDate}
                                                        />
                                                        {submitCount > 0 &&
                                                            <p className={styles.monthErrorMsg}>{errors.endDate}</p>
                                                        }
                                                    </Col>
                                                </div>
                                            }

                                        </Col>
                                        <Col className="mt-2 mb-3">
                                            <Row>
                                                <Col>
                                                    <CustomButton
                                                        buttonType="button"
                                                        type="defaultBtn"
                                                        label="Cancel"
                                                        handleClick={() => { setChartStatus(false); onCloseCustomDateRangeModal() }}
                                                    />
                                                </Col>
                                                <Col className="pl-0">
                                                    <CustomButton
                                                        buttonType="submit"
                                                        type="primaryBtn"
                                                        label="Submit"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Form>
                                )}
                            </Formik>
                        </Modal.Body>
                    </Modal>
                    {/* Custom modal to select month and year start */}

                    <div className={styles.analyticsBodyContainer}>
                        <Col>
                            <ul className={styles.topicContainer}>
                                <li className={activeTopic === 0 && styles.switchActive} onClick={() => setActiveTopic(0)}> <p className={styles.analyticsContentSwitch}>Snap Shot</p></li>
                                <li className={activeTopic === 1 && styles.switchActive} onClick={() => setActiveTopic(1)}><p className={styles.analyticsContentSwitch}>Trends</p></li>
                            </ul>
                            
                            {activeTopic === 0 &&

                                <div>
                                    <div className="mb-3">
                                        <Card className={styles.mainOuterCard}>
                                            <Card.Body>
                                                <Row>
                                                    <Col lg={4}>
                                                        <Row className={styles.showBoxFirstMainRow}>
                                                            <Col className={styles.rightCornerDiv}>
                                                                <div className={styles.showBox}>
                                                                    <p className={styles.showBoxTitleText}>Selection Ratio </p>
                                                                    <p className={styles.showBoxText}>{kpiAnalyticsDataSet.selection_ratio ? `${kpiAnalyticsDataSet.selection_ratio}%` : '0%'}</p>
                                                                </div>
                                                            </Col>
                                                            <Col>
                                                                <div className={styles.showBox}>
                                                                    <p className={styles.showBoxTitleText}>Offer acceptance rate</p>
                                                                    <p className={styles.showBoxText}>{kpiAnalyticsDataSet.offer_acceptance_rate ? `${kpiAnalyticsDataSet.offer_acceptance_rate}%` : '0%'}</p>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row className={styles.showBoxFirstMainRow}>
                                                            <Col className={styles.rightCornerDiv}>
                                                                <div className={styles.showBox}>
                                                                    <p className={styles.showBoxTitleText}>Time to hire</p>
                                                                    <p className={styles.showBoxText}>{kpiAnalyticsDataSet.time_to_hire ? kpiAnalyticsDataSet.time_to_hire : '0'}&nbsp;days</p>
                                                                </div>
                                                            </Col>
                                                            <Col></Col>
                                                        </Row>
                                                    </Col>
                                                    <Col lg={{ span: 3, offset: 3 }} className="text-right">
                                                        <span className={styles.selectedRangeLabel}>{((source_analytics_month_range.from).toString() === (source_analytics_month_range.to).toString()) ? "Data of:" : "Data from:"}</span><span className={styles.selectedRange}> {((source_analytics_month_range.from).toString() === (source_analytics_month_range.to).toString()) ? source_analytics_month_range.from : source_analytics_month_range.from + ' to ' + source_analytics_month_range.to}</span>
                                                    </Col>
                                                    <Col lg={2} className={styles.actionBtnContainer}>
                                                        <DropdownButton
                                                            menuAlign="right"
                                                            id="dropdown-menu-align-right"
                                                            className={styles.actionBtn}
                                                            title={
                                                                <div>
                                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M16 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M8 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M3 10H21" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                    <span className={styles.dividingLine}>|</span>
                                                                    <span className={styles.buttonText}>{sourceAnalyticsOverallPerformanceCalendarType === 0 ? 'Current Month' : sourceAnalyticsOverallPerformanceCalendarType === 1 ? 'Custom Range' : null}</span>
                                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M5.19995 7.59961L9.99995 12.3996L14.8 7.59961" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </div>
                                                            }
                                                        >
                                                            <Dropdown.Item className={styles.dropdownText} onClick={() => onClickSourceAnalyticsCurrentMonth()}>
                                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M8 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 10H21" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                                <span className={styles.dropdownTextSpan}>
                                                                    Current Month
                                                                </span>
                                                            </Dropdown.Item>
                                                            <Dropdown.Divider />
                                                            <Dropdown.Item className={styles.dropdownText} onClick={() => onClickCustomDateRange({ is_modal_open: true, modal_type: 0 })}>
                                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M8 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 10H21" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                                <span className={styles.dropdownTextSpan}>
                                                                    Custom Range
                                                                </span>
                                                            </Dropdown.Item >
                                                        </DropdownButton>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="mb-2 mt-5">
                                                        <p className={styles.subCardTopic}>All Sourcing analytics</p>
                                                        <Row>
                                                            <Col sm={12} lg={5}>
                                                                <Chart
                                                                    chartType="PieChart"
                                                                    options={
                                                                        (sourceAnalyticsDataSet.overall_analytics.from_external_recruiters_count === 0 && sourceAnalyticsDataSet.overall_analytics.internal_referral_count === 0 && sourceAnalyticsDataSet.overall_analytics.other_uploads === 0 && sourceAnalyticsDataSet.overall_analytics.registered_from_invitation_count === 0 && sourceAnalyticsDataSet.overall_analytics.registered_from_shareable_link_count === 0) ? pieOptionsDataNone : pieOptions
                                                                    }
                                                                    data={
                                                                        (sourceAnalyticsDataSet.overall_analytics.from_external_recruiters_count === 0 && sourceAnalyticsDataSet.overall_analytics.internal_referral_count === 0 && sourceAnalyticsDataSet.overall_analytics.other_uploads === 0 && sourceAnalyticsDataSet.overall_analytics.registered_from_invitation_count === 0 && sourceAnalyticsDataSet.overall_analytics.registered_from_shareable_link_count === 0) ?
                                                                            [['Media Type', 'Media Name'],
                                                                            ['', 1]
                                                                            ]
                                                                            :
                                                                            [
                                                                                ['Media Type', 'Media Name'],
                                                                                ['Registered Via Invitation', sourceAnalyticsDataSet.overall_analytics.registered_from_invitation_count],
                                                                                ['Registered Via Shareable Link', sourceAnalyticsDataSet.overall_analytics.registered_from_shareable_link_count],
                                                                                ['External Recruiters', sourceAnalyticsDataSet.overall_analytics.from_external_recruiters_count],
                                                                                ['Employee Referrals', sourceAnalyticsDataSet.overall_analytics.internal_referral_count],
                                                                                ['Other Upload', sourceAnalyticsDataSet.overall_analytics.other_uploads],
                                                                            ]
                                                                    }
                                                                />
                                                            </Col>
                                                            <Col className="mt-4" sm={12} lg={7}>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.shareableLinkBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Via Shareable Link</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.overall_analytics.registered_from_shareable_link_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.overall_analytics.registered_from_shareable_link_count === 0 && sourceAnalyticsDataSet.overall_analytics.total === 0) ? <span>0%</span> : <span> {Math.round(((sourceAnalyticsDataSet.overall_analytics.registered_from_shareable_link_count) / (sourceAnalyticsDataSet.overall_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.invitationBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Via Invitation</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.overall_analytics.registered_from_invitation_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.overall_analytics.registered_from_invitation_count === 0 && sourceAnalyticsDataSet.overall_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.overall_analytics.registered_from_invitation_count) / (sourceAnalyticsDataSet.overall_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.externalRecruiterBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>External Recruiters</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.overall_analytics.from_external_recruiters_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.overall_analytics.from_external_recruiters_count === 0 && sourceAnalyticsDataSet.overall_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.overall_analytics.from_external_recruiters_count) / (sourceAnalyticsDataSet.overall_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.employeeReferralBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Employee Referrals</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.overall_analytics.internal_referral_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.overall_analytics.internal_referral_count === 0 && sourceAnalyticsDataSet.overall_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.overall_analytics.internal_referral_count) / (sourceAnalyticsDataSet.overall_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.otherUploadBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Other Upload</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.overall_analytics.other_uploads}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.overall_analytics.other_uploads === 0 && sourceAnalyticsDataSet.overall_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.overall_analytics.other_uploads) / (sourceAnalyticsDataSet.overall_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col className="mb-2 mt-5">
                                                        <p className={styles.subCardTopic}>Shareable Link analytics</p>
                                                        <Row>
                                                            <Col lg={5}>
                                                                <Chart
                                                                    chartType="PieChart"
                                                                    options={
                                                                        (sourceAnalyticsDataSet.shareable_link_analytics.career_page_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.facebook_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.from_a_friend_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.linkedin_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.other_count === 0) ? pieAnalyticsOptionsDataNone : pieAnalyticsOptions
                                                                    }
                                                                    data={
                                                                        (sourceAnalyticsDataSet.shareable_link_analytics.career_page_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.facebook_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.from_a_friend_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.linkedin_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.other_count === 0) ?
                                                                            [['Media Type', 'Media Name'],
                                                                            ['', 1]
                                                                            ]
                                                                            :
                                                                            [
                                                                                ['Media Type', 'Media Name'],
                                                                                ['Joined Via Career Page', sourceAnalyticsDataSet.shareable_link_analytics.career_page_count],
                                                                                ['Joined Via Facebook', sourceAnalyticsDataSet.shareable_link_analytics.facebook_count],
                                                                                ['Joined Via LinkedIn', sourceAnalyticsDataSet.shareable_link_analytics.linkedin_count],
                                                                                ['Joined Via A Friend', sourceAnalyticsDataSet.shareable_link_analytics.from_a_friend_count],
                                                                                ['Joined Via Other', sourceAnalyticsDataSet.shareable_link_analytics.other_count],
                                                                            ]
                                                                    }
                                                                />
                                                            </Col>
                                                            <Col className="mt-4">
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.careerPageBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Via Career Page</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.shareable_link_analytics.career_page_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.shareable_link_analytics.career_page_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.shareable_link_analytics.career_page_count) / (sourceAnalyticsDataSet.shareable_link_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.facebookBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Via Facebook</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.shareable_link_analytics.facebook_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.shareable_link_analytics.facebook_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.shareable_link_analytics.facebook_count) / (sourceAnalyticsDataSet.shareable_link_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.linkedinBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Via LinkedIn</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.shareable_link_analytics.linkedin_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.shareable_link_analytics.linkedin_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.total === 0) ? <span> 0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.shareable_link_analytics.linkedin_count) / (sourceAnalyticsDataSet.shareable_link_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.friendBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Via A Friend</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.shareable_link_analytics.from_a_friend_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.shareable_link_analytics.from_a_friend_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.shareable_link_analytics.from_a_friend_count) / (sourceAnalyticsDataSet.shareable_link_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={1} className="align-self-center">
                                                                        <div className={styles.otherBall}></div>
                                                                    </Col>
                                                                    <Col>
                                                                        <span className={styles.pieChartLabels}>Via Other</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelValue}>{sourceAnalyticsDataSet.shareable_link_analytics.other_count}</span>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <span className={styles.pieChartLabelPrecentageValue}>{(sourceAnalyticsDataSet.shareable_link_analytics.other_count === 0 && sourceAnalyticsDataSet.shareable_link_analytics.total === 0) ? <span>0%</span> : <span>{Math.round(((sourceAnalyticsDataSet.shareable_link_analytics.other_count) / (sourceAnalyticsDataSet.shareable_link_analytics.total)) * 100)}%</span>}</span>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div>

                            }
                            {activeTopic === 1 &&

                                <div className="mb-3">
                                    <Card className={styles.mainOuterCard}>
                                        <Card.Body>
                                            <Row className="mb-3 mt-3">
                                                <Col lg={2}>
                                                    <span className={styles.mainCardTopic}>KPIs Trends</span>
                                                </Col>
                                                <Col lg={{ span: 2}}>
                                                    <Select
                                                        options={kpiSectionAllTrendTypes}
                                                        class="react-select__control"
                                                        value={kpiSectionDefaultSelectedTrendType}
                                                        onChange={(e) => { setKpiSectionDefaultSelectedTrendType(e) }}
                                                        styles={
                                                            {
                                                                ...styles,
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                    border: '1px solid #bdbdbd', // default border color
                                                                    borderRadius: '6px',
                                                                    boxShadow: 'none', // no box-shadow
                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                    fontWeight: 'var(--app-bold-font-weight)',
                                                                    fontSize: 'var(--app-small-font-size)',
                                                                    color: '#24859A !important'
                                                                }),
                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                    return {
                                                                        ...styles,
                                                                        background: isDisabled
                                                                            ? null
                                                                            : isSelected
                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                : isFocused
                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                    : null,
                                                                        color: isDisabled
                                                                            ? '#ccc'
                                                                            : isSelected
                                                                                ? '#24859A'
                                                                                : '#24859A',
                                                                        cursor: isDisabled ? 'not-allowed' : 'default',
                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                        fontWeight: 'var(--app-bold-font-weight)',
                                                                        fontSize: 'var(--app-small-font-size)',

                                                                        ':active': {
                                                                            ...styles[':active'],
                                                                            background:
                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                        },
                                                                    };
                                                                },
                                                                singleValue: (styles, { data }) => {
                                                                    return {
                                                                        ...styles,
                                                                        color: '#24859A !important',
                                                                    };
                                                                },
                                                            }
                                                        }
                                                    />
                                                </Col>
                                                <Col  lg={{ span: 3,offset: 3 }} className="text-right">
                                                    <span className={styles.selectedRangeLabel}>{((kpi_monthly_trend_range.from).toString() === (kpi_monthly_trend_range.to).toString()) ? "Data of:" : "Data from:"}</span><span className={styles.selectedRange}>{((kpi_monthly_trend_range.from).toString() === (kpi_monthly_trend_range.to).toString()) ? kpi_monthly_trend_range.from : kpi_monthly_trend_range.from + ' to ' + kpi_monthly_trend_range.to}</span>
                                                </Col>
                                                <Col lg={2} className={styles.actionBtnContainer}>
                                                    <DropdownButton
                                                        menuAlign="right"
                                                        id="dropdown-menu-align-right"
                                                        className={styles.actionBtn}
                                                        title={
                                                            <div>
                                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M16 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M8 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M3 10H21" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                                <span className={styles.dividingLine}>|</span>
                                                                <span className={styles.buttonText}>{kpiMonthlyTrendCalendarType === 0 ? 'Past 03 Months' : kpiMonthlyTrendCalendarType === 1 ? 'Custom Range' : null}</span>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M5.19995 7.59961L9.99995 12.3996L14.8 7.59961" stroke="#2DA6C0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            </div>
                                                        }
                                                    >

                                                        <Dropdown.Item className={styles.dropdownText} onClick={() => MonthlyTrendPastThreeMonths()}>
                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M16 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M3 10H21" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                            <span className={styles.dropdownTextSpan}>
                                                                Past 03 Months
                                                            </span>
                                                        </Dropdown.Item>
                                                        <Dropdown.Divider />
                                                        <div className={styles.dropdownText} onClick={() => onClickCustomDateRange({ is_modal_open: true, modal_type: 1 })}>
                                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M16 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8 2V6" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M3 10H21" stroke="#24859A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                            <span className={styles.dropdownTextSpan}>
                                                                Custom Range
                                                            </span>
                                                        </div>
                                                    </DropdownButton>

                                                </Col>
                                            </Row>
                                            <Col>
                                                <Chart
                                                    chartType="LineChart"
                                                    options={kpiSectionDefaultSelectedTrendType.value === 0 ? selection_ratio_options : kpiSectionDefaultSelectedTrendType.value === 1 ? offer_acceptance_rate_options : kpiSectionDefaultSelectedTrendType.value === 2 ? time_to_hire_options : null}
                                                    data={
                                                        kpiSectionDefaultSelectedTrendType.value === 0 ? kpiMonthlyTrendDataSet.selection_ratio
                                                            : kpiSectionDefaultSelectedTrendType.value === 1 ? kpiMonthlyTrendDataSet.offer_acceptance_rate
                                                                : kpiSectionDefaultSelectedTrendType.value === 2 ? kpiMonthlyTrendDataSet.time_to_hire
                                                                    : null
                                                    }
                                                />
                                            </Col>
                                            <div className={styles.chartDivider}>

                                            </div>
                                            <Row className="mb-3">
                                                <Col lg={2}>
                                                    <span className={styles.mainCardTopic}>Sources Trends</span>
                                                </Col>
                                                <Col lg={2}>
                                                    <Select
                                                        options={allTrendTypes}
                                                        class="react-select__control"
                                                        value={defaultSelectedTrendType}
                                                        onChange={(e) => { setDefaultSelectedTrendType(e) }}
                                                        styles={
                                                            {
                                                                ...styles,
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                    border: '1px solid #bdbdbd', // default border color
                                                                    borderRadius: '6px',
                                                                    boxShadow: 'none', // no box-shadow
                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                    fontWeight: 'var(--app-bold-font-weight)',
                                                                    fontSize: 'var(--app-small-font-size)',
                                                                    color: '#24859A !important'
                                                                }),
                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                    return {
                                                                        ...styles,
                                                                        background: isDisabled
                                                                            ? null
                                                                            : isSelected
                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                : isFocused
                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                    : null,
                                                                        color: isDisabled
                                                                            ? '#ccc'
                                                                            : isSelected
                                                                                ? '#24859A'
                                                                                : '#24859A',
                                                                        cursor: isDisabled ? 'not-allowed' : 'default',
                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                        fontWeight: 'var(--app-bold-font-weight)',
                                                                        fontSize: 'var(--app-small-font-size)',

                                                                        ':active': {
                                                                            ...styles[':active'],
                                                                            background:
                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                        },
                                                                    };
                                                                },
                                                                singleValue: (styles, { data }) => {
                                                                    return {
                                                                        ...styles,
                                                                        color: '#24859A !important',
                                                                    };
                                                                },
                                                            }
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                            <Col className='mb-3'>
                                                <Chart
                                                    chartType="LineChart"
                                                    options={defaultSelectedTrendType.value === 0 ? overall_analytics_options : defaultSelectedTrendType.value === 1 ? shareable_link_analytics_options : null}
                                                    data={
                                                        defaultSelectedTrendType.value === 0 ? sourceAnalyticsMonthlyTrendDataSet.overall_analytics
                                                            : defaultSelectedTrendType.value === 1 ? sourceAnalyticsMonthlyTrendDataSet.shareable_link_analytics
                                                                : null
                                                    }
                                                />
                                            </Col>
                                        </Card.Body>
                                    </Card>
                                </div>


                            }
                        </Col>
                    </div>
                </div>)
            }
        </div>
    )
}

export default Analytics;
